import { Programme } from "core/types";
import { GridRowProps } from "./types";
import dateWrapper from "core/lib/date-wrapper";
import { durationFilter } from "core/lib/time-methods";
import { getAnalyticTags } from "core/lib/analytics-methods";
import { times } from "core/times";

export const getOtherDayRowItem = (index: number, props: GridRowProps) => {
  const { timeWindow, gridCheck, rowTop } = props;

    const style: Record<string, string | number> = {};
  style.left = `${props.timeChunkWidth * index}px`;

  const isRegularDay =
    timeWindow[0] <= times[index] &&
    times[index] <= timeWindow[1];

  const isLeft =
    timeWindow[0] > "17:00" &&
    timeWindow[1] < timeWindow[0] &&
    gridCheck[0] >= 0;

  const isRight =
    "00:00" < timeWindow[1] &&
    timeWindow[1] < timeWindow[0] &&
    gridCheck[0] < 0;

  const key = `item-${rowTop}-${index}`;

  return {
    index,
    key,
    style,
    isRegularDay,
    isLeft,
    isRight
  };
}

export const getSameDayRowItem = (index: number, show: Programme, props: GridRowProps) => {
  const { adjustedCurrentTime, PMM } = props;

  const showStartDateTime = dateWrapper(show.startTime);
  const showEndDateTime = dateWrapper(show.endTime);
  const showStartTime = showStartDateTime.shortTime;
  const showEndTime = showEndDateTime.shortTime;
  const [gridTimeInViewStart, gridTimeInViewEnd] = props.timeWindow;
  const endsOnNextDay = showEndDateTime.yearMonthDay() > showStartDateTime.yearMonthDay();

  // FIXME: This whole section of code needs to be refactored to use better datetime comparisons...
  const isLeft =
    gridTimeInViewStart > "16:00" &&
    gridTimeInViewEnd < gridTimeInViewStart &&
    (gridTimeInViewStart <= showEndTime || endsOnNextDay) &&
    props.gridCheck[0] >= 0;

  const isRight =
    gridTimeInViewEnd < gridTimeInViewStart &&
    props.gridCheck[0] < 0;

  const isRegular =
    (gridTimeInViewStart <= showEndTime || endsOnNextDay) &&
    gridTimeInViewEnd >= showStartTime;

  const isGap =
    gridTimeInViewStart >= showStartTime &&
    !endsOnNextDay &&
    gridTimeInViewEnd <= showEndTime;

  const shouldShow: boolean = isRegular || isLeft || isRight || isGap;

  if (!shouldShow) {
    return null;
  }

  const style: Record<string, string | number> = {};

  const startTime = new Date(show.startTime);
  const endTime = new Date(show.endTime);

  let duration = endTime.valueOf() - startTime.valueOf();

  const ppm = PMM || 0;

  if (ppm == 0) {
    console.log("NO PPM " + show.title);
  }

  let offset = (startTime as any) - props.midnight;
  offset = offset / ppm;
  duration = duration / ppm;

  const durationClass = durationFilter(duration);

  if (!durationClass) {
    const fixedWidth = (duration - 4) + "px";
    style["width"] = fixedWidth;
    style["minWidth"] = fixedWidth;
    style["maxWidth"] = fixedWidth;

    // Padding inside each grid horizontally
    if (duration <= 40) {
      style["paddingLeft"] = "5px";
      style["paddingRight"] = "5px";
    }
  }

  if (offset >= 0) {
    style["left"] = `${offset}px`;
  }

  const isActive = show.startTime < adjustedCurrentTime && adjustedCurrentTime < show.endTime;

  const analytics = getAnalyticTags({
    component_name: "tv_guide_channel_show_clicks",
    component_type: "show_clicks",
    show_name: show.title,
    show_runtime: `${show.startTime}_${show.endTime}`,
    target_page_url: "_self"
  });

  let cssClass = "grid-block";

  if (durationClass) {
    cssClass += ` ${durationClass}`;
  }

  if (isActive) {
    cssClass += " active";
  }

  return {
    analytics,
    cssClass,
    show,
    style,
    isActive,
    showStartTime,
  };
}
